<template>
  <div class="product-inform">
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <span v-text="title" />
        <div
          class="custom-check pt-0"
          v-if="data != '' && data != undefined && false"
        >
          <input class="pull-right" type="checkbox" id="return" />
          <label for="return">&nbsp; Return</label>
        </div>
      </div>
      <div class="card-body">
        <div class="product-detail" v-if="data != '' && data != undefined">
          <b-row>
            <b-col md="4">
              <div class="mb-2">
                <small class="mb-1" v-text="product.batch.type + ' number'" />
                <p
                  class="fs-12"
                  :class="[
                    product.batch.value == 'No batch/serial tracking'
                      ? 'fs-12 text-muted'
                      : '',
                  ]"
                  v-text="product.batch.value"
                />
              </div>
            </b-col>
            <b-col md="4">
              <div class="mb-2">
                <small class="mb-1">MRP</small>
                <p
                  class="fs-12"
                  v-text="currencySymbol + formatAmount(product.mrp)"
                />
              </div>
            </b-col>
            <b-col md="4">
              <div class="mb-2">
                <small class="mb-1">Tax Details</small>
                <p
                  :class="{ 'fs-12': true, 'tax-avail': product.isTax }"
                  v-text="product.tax"
                  @click="openTaxModal"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <div class="mb-2">
                <small class="mb-1">Salesperson</small>
                <p
                  class="fs-12"
                  :class="[
                    product.salesperson.id == null ? 'text-muted fs-12' : '',
                  ]"
                  v-text="product.salesperson.name"
                />
              </div>
            </b-col>
            <b-col md="4">
              <div class="mb-2">
                <small class>Item Remark</small>
                <p
                  class="fs-12"
                  v-text="product.remark"
                  :class="[
                    product.remark == 'No remark added'
                      ? 'text-muted fs-12'
                      : '',
                  ]"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8"
              ><div class="mb-2">
                <small class="mb-1">Promotions</small>
                <p
                  class="fs-12"
                  :class="[
                    product.promotion == 'No promotion applied'
                      ? 'fs-12 text-muted'
                      : '',
                  ]"
                  v-text="product.promotion"
                /></div
            ></b-col>
            <b-col md="4">
              <div class="mb-2">
                <small class>Inventory Status</small>
                <p
                  class="fs-12"
                  :class="
                    parseFloat(product.inventory) > 0
                      ? 'text-success'
                      : 'text-danger'
                  "
                  v-text="product.inventory + ' Units Available'"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="product-detail" v-else>
          <div class="row align-items-center notification" style="height:100%">
            <p class="text-center w-100 text-muted">
              Select a product to view additional information.
            </p>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      centered
      hide-footer
      :title="`Tax Details | ${data.barcode}`"
      ref="tax-details-prod"
      id="tax-details-prod"
      size="sm"
    >
      <div v-if="!checkEmpty(data)">
        <b-row class="tax-detials-el">
          <b-col md="6">Tax Name:</b-col>
          <b-col class="text-right" v-text="data.t_data.tax_name" />
        </b-row>
        <b-row class="tax-detials-el">
          <b-col md="6">
            Tax Type:
          </b-col>
          <b-col
            md="6"
            class="text-right"
            v-text="
              data.t_data.tax_type.toLowerCase() == 'exc'
                ? 'Exclusive'
                : 'Inclusive'
            "
          />
        </b-row>
        <b-row class="tax-detials-el">
          <b-col md="6">
            HSN:
          </b-col>
          <b-col md="6" class="text-right" v-text="data.t_data.hsn" />
        </b-row>
        <b-row class="tax-detials-el">
          <b-col md="6">
            Taxable:
          </b-col>
          <b-col
            md="6"
            class="text-right"
            v-text="currencySymbol + formatAmount(data.t_data.taxable)"
          />
        </b-row>
        <b-row class="tax-detials-el">
          <b-col md="6">
            CESS:
          </b-col>
          <b-col
            md="6"
            class="text-right"
            v-text="currencySymbol + formatAmount(data.t_data.cessamt)"
          />
        </b-row>
        <b-row class="tax-detials-el">
          <b-col md="6">
            CGST:
          </b-col>
          <b-col
            md="6"
            class="text-right"
            v-text="currencySymbol + formatAmount(data.t_data.cgstamt)"
          />
        </b-row>
        <b-row class="tax-detials-el">
          <b-col md="6">
            SGST:
          </b-col>
          <b-col
            md="6"
            class="text-right"
            v-text="currencySymbol + formatAmount(data.t_data.sgstamt)"
          />
        </b-row>
        <b-row class="tax-detials-el">
          <b-col md="6">
            Total Tax:
          </b-col>
          <b-col
            md="6"
            class="text-right"
            v-text="currencySymbol + formatAmount(data.t_data.tax)"
          />
        </b-row>
        <!-- <b-row class="mt-4">
          <b-button block variant="outline-primary">Dismiss</b-button>
        </b-row> -->
      </div>
    </b-modal>
    <!-- <b-modal id="mrp" class="slt-mrp" size="sm" title="Select MRP" hide-footer centered>
                  <b-form inline>
                    <b-form-group class="py-2 w-100">
                      <ul class="py-0 px-0 w-100 h-auto" style="display: inline-flex">
                        <li class="w-100 p-0">
                          <div class="row">
                            <div class="col-md-6">300.00</div>
                            <div class="col-md-6">
                              <b-form-radio value="awadh" name="first" class="float-right w-25"></b-form-radio>
                            </div>
                          </div>
                          <ul class="p-0">
                            <li class="col-md-9">/li>
                            <li class="col-md-3 p-0">
                             
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <div class="row bg-light py-2">
                        <div class="col-md-6 py-1">300.00</div>
                        <div class="col-md-6 py-1">
                          <b-form-radio value="awadh" name="first" class="float-right w-25"></b-form-radio>
                        </div>
                      </div>
                    </b-form-group>
                  </b-form>
                  <button
                    class="btn btn-secondary float-right px-5 w-50"
                    @click="putbatch()"
                    :disabled="$loading"
                  >
                    <span v-if="$loading == false">Update</span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </button>
                </b-modal>-->
    <!-- <v-select
                  :options="data.price_list"
                  v-model="selectMRP"
                  :selected="data.unit_mrp"
                  :disabled="data.price_list.length === 1 || data.price_list.length === 0"
                />-->
    <!-- <select>
                  <option
                    v-for="item in data.price_list"
                    :key="item"
                    :value="item"
                    :selected="data.unit_mrp"
                  >{{item}}123</option>
                </select>-->
    <!-- <b-form>
                  <b-form-input
                    placeholder="No Batch Available"
                    v-if="this.batchList.length <= 0"
                    readonly
                  ></b-form-input>
                  <div v-for="items in batchList">
                    <b-form-input
                      v-if="this.batchList.length <= 1 && this.batchList.length > 0"
                      :placeholder="items.text"
                      readonly
                    ></b-form-input>
                  </div>
                  <b-form-input
                    v-if="this.batchList.length > 1"
                    @click="openBatchListPopup()"
                    placeholder="Select Batch Numbers"
                  ></b-form-input>
                </b-form>-->
    <!-- <b-modal ref="batch" size="md" title="Select Batch" hide-footer centered>
                  <b-form inline>
                    <b-form-group class="p-0 pt-2 w-100">
                      <b-input-group>
                        <b-input-group-append aria-readonly>
                          <span class="input-group-text">
                            <font-awesome-icon :icon="['fas', 'search']" />
                          </span>
                        </b-input-group-append>
                        <b-input-group-prepend v-show="batchNumber !=''">
                          <span class="input-group-text">
                            <b-button @click="viewPassword()" class="px-4">Search</b-button>
                          </span>
                        </b-input-group-prepend>
                        <b-form-input
                          class="px-5 mb-3"
                          autocomplete="off"
                          type="text"
                          size="lg"
                          v-model="batchNumber"
                          placeholder="Search Batch Number"
                        ></b-form-input>
                      </b-input-group>
                      <ul class="p-0">
                        <li>
                          <ul v-for="item in batchList" class="px-0">
                            <li>{{ item.text }}</li>
                            <li>
                              <b-form-radio
                                v-model="selected"
                                class="pull-right"
                                name="some-radios"
                                :id="item.text"
                                :value="item.text"
                              ></b-form-radio>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </b-form-group>
                  </b-form>
                  <button
                    class="btn btn-secondary float-right px-5 w-25"
                    @click="putbatch()"
                    :disabled="$loading"
                  >
                    <span v-if="$loading == false">Update</span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </button>
                </b-modal>-->
    <!-- <v-select
                  :options="batchList"
                  v-model="batchCode"
                  :disabled="batchList.length == 0"
                />-->
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "product-information",
  components: {},
  props: ["data"],
  data() {
    return {
      title: "Product Name & Description (Barcode)",
      selectMRP: null,
      batchCode: null,
      searchableName: true,
      applyPromotion: null,
      isShow: false,
      batchNumber: "",
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    product() {
      let temp = {
        batch: {
          type: "Batch",
          value: "No batch/serial tracking",
        },
        mrp: this.data.unit_mrp,
        salesperson: { id: this.data.salesman_id, name: "" },
        remark: this.checkEmpty(this.data.remark)
          ? "No remark added"
          : this.data.remark,
        inventory: this.data.stock,
      };

      if (this.data.batch_id == "0" && this.data.serial_id == "0") {
        temp.batch.type = "Batch";
        temp.batch.value = "No batch/serial tracking";
      } else if (this.data.batch_id != 0) {
        temp.batch.type = "Batch";
        temp.batch.value = this.data.batch_id;
      } else if (this.data.serial_id != 0) {
        temp.batch.type = "Serial";
        temp.batch.value = this.data.serial_id;
      }

      if (this.checkEmpty(temp.salesperson.id))
        temp.salesperson.name = "Not Specified";
      else {
        this.state.billing.billing.salesPerson.data.filter((item) => {
          if (item.salesman_id == temp.salesperson.id)
            temp.salesperson.name = item.first_name + " " + item.last_name;
        });
      }

      if (this.data.offer_data.applied_offers.length == 0)
        temp.promotion = "No promotion applied";
      else temp.promotion = this.data.offer_data.applied_offers[0].message;

      temp.tax = this.data.t_data.tax_name;
      temp.isTax = false;

      if (!this.checkEmpty(this.data.t_data.tax)) {
        temp.tax += " | " + this.data.t_data.tax_type;
        temp.isTax = true;
      }
      return temp;
    },
    // batchName() {
    //   let data = "";
    //   if (this.batchList.length < 1) {
    //     data = "No Batch Available";
    //   }
    //   return data;
    // },
    batchList() {
      let data = [];
      // data.push({ value: "", text: "Select Batch Numbers" });
      if (this.data.batch != undefined) {
        this.data.batch.map((item) => {
          data.push({ value: item.batch_no, text: item.batch_no });
        });
      }
      return data;
    },
    // batchListSingle() {
    //   let data = [];
    //   // data.push({ value: "", text: "Select Batch Numbers" });
    //   if (this.data.batch != undefined) {
    //     this.data.batch.map(item => {
    //       data.push({ value: item.batch_no, text: item.batch_no });
    //     });
    //   }
    //   return data;
    // }
  },
  watch: {
    data() {
      if (!this.checkEmpty(this.data)) {
        this.selectMRP = this.data.unit_mrp;
        this.title = this.data.barcode + " - " + this.data.name;
      } else {
        this.title = "Product Name & Description (Barcode)";
      }
    },
  },
  methods: {
    openTaxModal() {
      if (this.product.isTax) {
        this.$refs["tax-details-prod"].show();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.gst-header {
  color: $dark-card-text;
  font-size: 11px;
}
.theme-dark .product-detail .v-dropdown-container,
.theme-dark .product-detail .v-select-toggle,
.theme-dark .product-detail .v-dropdown-container ul {
  background-color: #303030 !important;
  color: #c0c0c0;
}

.theme-dark .v-dropdown-item.selected,
.theme-dark .v-dropdown-item:hover {
  background-color: #202020 !important;
}
.theme-dark .list-group-item {
  background-color: #303030;
  color: #c0c0c0;
}
.theme-dark h5 {
  color: #c0c0c0;
}
.theme-light .product-inform small {
  color: #808080;
}
.product-detail .v-select.disabled .v-select-toggle {
  background-color: transparent !important;
  border: none;
  padding: 0px;
}

.product-detail .v-select-toggle,
.product-detail .input-group {
  background: transparent !important;
  padding: 0px !important;
  border: none !important;
}

.theme-dark .product-detail .form-control,
.theme-dark .product-detail .form-control:focus {
  border: 1px #606060 solid !important;
  background-color: transparent !important;
  box-shadow: none;
}
.product-detail .v-dropdown-container,
.theme-dark .product-detail .v-select-toggle,
.theme-dark .product-detail .v-dropdown-container ul {
  background-color: transparent !important;
}
.modal-body {
  form {
    ul {
      background-color: #303030;

      border-radius: 5px;

      @include custom-scrollbar();
      li {
        list-style-type: none;
        padding: 10px 0px;
        color: #c0c0c0;
        ul {
          display: inline-flex;
          width: 100%;
          height: auto;

          &:hover {
            background-color: #202020;
            border-radius: 0px;
          }
          li {
            padding: 0 20px;
            color: #808080;
            width: 85%;
            margin-top: 8px;
          }
          // &:first-child {
          //   display: none;
          // }
          li + li {
            width: 10%;
            margin: 7px 0;
          }
        }
      }
    }
  }
  .custom-check {
    label {
      font-size: inherit;
      color: inherit;
    }
  }
}
.theme-light .modal-body form ul li ul:hover {
  background: #e4e4e4;
}
.product-detail .form-control,
.product-detail .input-group-text {
  border: 1px solid #ced4da;
}
.theme-dark .product-detail .form-control,
.theme-dark .product-detail .input-group-text {
  border: 1px solid #606060;
}
form .input-group-prepend .input-group-text .input-group-text {
  background: transparent;
}
form .input-group-prepend .input-group-text {
  background-color: transparent;
}
form .input-group-prepend .input-group-text button {
  border-bottom-left-radius: 0px !important;
  border-top-left-radius: 0px !important;
}
form .input-group-prepend {
  margin-right: -1px;
  right: 0;
  position: absolute;
  z-index: 99;
  top: 0;
  span {
    padding: 0px;
    border: none;
    button {
      border-radius: 0px;
    }
  }
}
form .input-group-append {
  margin-right: -1px;
  left: 15px;
  position: absolute;
  z-index: 99;
  top: 12px;

  span {
    padding: 0px;
    border: none;
    background-color: #303030;

    button {
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
    }
  }
}
.theme-light form .input-group-append span,
.theme-light .modal-body form ul {
  background-color: #f4f4f4;
}
// .custom-check input {
//   padding: 0;
//   height: initial;
//   width: initial;
//   margin-bottom: 0;
//   display: none;
//   cursor: pointer;
// }
// .custom-check label {
//   position: relative;
//   cursor: pointer;
//   justify-content: center;
//   padding-left: 0px;
//   margin-bottom: 0;
// }
.form-control {
  border-radius: 5px !important;
}
button {
  border-radius: 5px !important;
}
.btn-secondary {
  padding: 10px 0px;
}
.theme-light .input-group .input-group-append span .fa-search {
  opacity: 0.3;
}
// .w-75 {
//   width: 90% !important;
// }
// .w-25 {
//   width: 10% !important;
// }
.product-detail form input {
  background: #f0f0f0;
}
input {
  cursor: pointer;
}
.clearfix {
  clear: both;
}
input:read-only,
.form-control {
  background: transparent !important;
  border: 1px solid #ced4da;
}
.text-danger {
  border-right: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.input-group-append .input-group-text {
  border-left: none !important;
}
.bg-light {
  background-color: #f0f0f0 !important;
}
.bg-light:hover {
  background-color: #e4e4e4 !important;
}
.product-detail {
  @include custom-scrollbar();
}
.tax-avail {
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
}
.tax-detials-el {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  &:col-md-6 {
    padding-left: 0px;
  }
}
.tax-detials-el {
  &:nth-child(even) {
    background: #f8f8f8 !important;
  }
}
.theme-dark .tax-detials-el {
  &:nth-child(even) {
    background: #303030 !important;
  }
  color: #f0f0f0;
}
</style>
